"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const equal = require("fast-deep-equal");
const ValueObject_1 = require("../../Common/ValueObject");
class Creator extends ValueObject_1.ValueObject {
    constructor(creator) {
        super();
        this.id = "";
        this.name = "";
        if (creator) {
            this.id = creator.id || this.id;
            this.name = creator.name || this.name;
        }
    }
    *GetEqualityComponents() {
        yield* [this.id, this.name];
    }
    static from(id, name) {
        return new Creator({ id, name });
    }
    isSame(someone) {
        return equal(this, someone);
    }
    toAttendee() {
        if (this === Creator.Nobody)
            return Attendee.Nobody;
        return Attendee.from(this.id, this.name);
    }
    static fromAttendee(a) {
        if (a === Attendee.Nobody)
            return Creator.Nobody;
        return new Creator({ id: a.id, name: a.name });
    }
}
Creator.Nobody = new Creator();
exports.Creator = Creator;
class Attendee extends ValueObject_1.ValueObject {
    constructor(attendee) {
        super();
        this.id = "";
        this.name = "";
        if (attendee) {
            this.id = attendee.id || this.id;
            this.name = attendee.name || this.name;
        }
    }
    *GetEqualityComponents() {
        yield* [this.id, this.name];
    }
    static from(id, name) {
        return new Attendee({ id, name });
    }
    isSame(someone) {
        return equal(this, someone);
    }
    static fromCreator(c) {
        if (c === Creator.Nobody)
            return Attendee.Nobody;
        return Attendee.from(c.id, c.name);
    }
}
Attendee.Nobody = new Attendee();
exports.Attendee = Attendee;
//# sourceMappingURL=Attendee.js.map